import { render } from "./mineSweeper.vue?vue&type=template&id=1f1a4ce0&scoped=true"
import script from "./mineSweeper.vue?vue&type=script&lang=js"
export * from "./mineSweeper.vue?vue&type=script&lang=js"

import "../assets/css/game_mine.css?vue&type=style&index=0&id=1f1a4ce0&scoped=true&lang=css"
import "./mineSweeper.vue?vue&type=style&index=1&id=1f1a4ce0&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1a4ce0"]])

export default __exports__